<template>
  <div>
    <div class="mx-auto d-flex align-center pa-3" style="position: sticky; top: 0; z-index: 2; max-width: 500px;">
      <v-text-field
        class="white"
        outlined dense rounded hide-details clearable
        label="Search"
        :value="search"
        :disabled="!!loadingProviderId"
        @input="x => $emit('input-search', x)"
      />
      <v-menu offset-y content-class="max-height-80vh" nudge-left="10" :disabled="!!loadingProviderId">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="d-flex align-center ml-2" style="cursor: pointer;">
            <country-flag :country="country" />
            <v-icon v-html="mdiMenuDown" />
          </div>
        </template>
        <v-list dense>
          <v-list-item
            v-for="code in SUPPORTED_COUNTRY_CODES" :key="code"
            :input-value="country == code"
            @click="$emit('input-country', code)"
          >
            <country-flag class="my-n1 ml-n1 mr-2 flex-shrink-0" style="transform: scale(.8);" :country="code" />
            <v-list-item-title>{{code | country-name}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div v-if="COUNTRY_CODE != country" class="text-center caption font-italic warning--text pa-3">
      <v-icon class="mr-1" color="warning" v-html="mdiAlert" /> These gift cards can only be redeemed in {{country | country-name}}
    </div>

    <div v-if="loadProductsStatus.pending" class="d-flex justify-center align-center pa-3">
      <v-progress-circular indeterminate />
    </div>
    <template v-else-if="filtered.length">
      <v-row class="relative pt-3" style="z-index: 1;">
        <v-col v-for="p in filtered" :key="p.id"  cols="6" sm="4" md="3">
          <v-card
            class="gc-border"
            dark hover
            :loading="loadingProviderId == p._providerId"
            :disabled="loadingProviderId == p._providerId"
            :to="$routeAssign({ params: { providerId: p._providerId } })"
          >
            <v-img :aspect-ratio="300 / 190" :src="p.img" />
          </v-card>
          <div class="pt-1 overline short text-center">{{p.name}}</div>
        </v-col>
      </v-row>
      <div class="mt-8 caption">The merchants represented are not sponsors of the rewards or otherwise affiliated with Ellacard. The logos and other identifying marks attached are trademarks of and owned by each represented company and / or its affiliates. Please visit each company’s website for additional terms and conditions.</div>
    </template>
    <div v-else class="overline short">
      No gift cards found
    </div>
  </div>
</template>

<style>
.max-height-80vh {
  max-height: 80vh;
}
</style>

<script>
import CountryFlag from '@/components/CountryFlag.vue';
import Currency from '@/components/Currency.vue';
import GiftcardAmount from '@/components/GiftcardAmount.vue';
import { cache, ssr } from '@/mixins/ssr.js';
import { SUPPORTED_COUNTRY_CODES, getFee } from '@/utils/giftcard.js';
import { COUNTRY_CODE } from '@/utils/intl.js';
import uuid4 from '@/utils/uuid.js';
import { mdiAlert, mdiClose, mdiMenuDown } from '@mdi/js';

export default {
  name: 'giftcard-browser',

  mixins: [ ssr ],

  components: {
    CountryFlag,
    Currency,
    GiftcardAmount
  },

  props: {
    search: String,
    country: String,
    loadingProviderId: String
  },

  data() {
    return {
      products: [],
      loadProductsStatus: this.$track('loadProducts')
    };
  },

  computed: {
    hydrated() {
      return !this.loadProductsStatus.pending;
    },

    filtered() {
      if (!this.search)
        return this.products;
      const terms = this.search.split(/\s+/).filter(x => !!x).map(x => x.toLowerCase());
      return this.products.filter(x => {
        for (const term of terms)
          if (x._nameLower.includes(term))
            return true;
        return false;
      });
    }
  },

  created() {
    Object.assign(this, { COUNTRY_CODE, SUPPORTED_COUNTRY_CODES, mdiAlert, mdiClose, mdiMenuDown });
  },

  methods: {
    async loadProducts() {
      this.products = [];
      const products = await cache(this.$call)('list-giftcards-by-country', { country: this.country });
      for (const p of products) {
        p._nameLower = p.name.toLowerCase();
        p._providerId = p.src + ':' + p.id;
      }
      this.products = products;
    }
  },

  watch: {
    country: {
      immediate: true,
      handler() {
        this.loadProducts();
      }
    }
  }
}
</script>
